import escapeStringRegexp from 'escape-string-regexp';

// Lightweight helper for URL manipulations only — no HTTP in theme bundle
export default {
    baseUrl : '',
    host : '',
    decodeHtmlEntityAmpersand(string){
        return string.replace('&#038;', '&');
    },
    indexOfFirstACFFlexibleContentLayout(flexibleContent, layout){
        for (let i = 0; i < flexibleContent.length; i++) {
            if (flexibleContent[i]['acf_fc_layout'] === layout) {
                return i;
            }
        }
    },
    indexOfLastACFFlexibleContentLayout(flexibleContent, layout){
        let i = flexibleContent.length;
        while (i--) {
            if (flexibleContent[i]['acf_fc_layout'] === layout) {
                return i;
            }
        }
    },
    getHierarchicalMenuItems(menuItems, menuItemId){
        if (menuItemId === undefined) {
            menuItemId = '0';
        }
        return menuItems.reduce((reduced, menuItem)=>{
            if (parseInt(menuItem['menu_item_parent']) === parseInt(menuItemId)) {
                menuItem._childMenuItems = this.getHierarchicalMenuItems(menuItems, menuItem['ID']);
                reduced.push(menuItem);
            }
            return reduced;
        }, []);
    },
    getQueryStringForPostIds(postIds){
        let queryString = '';
        if (Array.isArray(postIds)) {
            for (let i = 0; i < postIds.length; i++) {
                queryString += '&include[]=' + postIds[i];
            }
        }
        return queryString;
    },
    getQueryStringForTaxonomyTags(tags, taxonomy){
        if (taxonomy === undefined) {
            taxonomy = 'tag';
        }
        let queryString = '&filter[' + taxonomy + ']=';
        if (Array.isArray(tags)) {
            for (let i = 0; i < tags.length; i++) {
                queryString += tags[i] + ',';
            }
        }
        return queryString;
    },
    getQueryStringForTaxonomyTagIds(tags, taxonomy){
        if (taxonomy === undefined) {
            taxonomy = 'tag';
        }
        let queryString = '';
        if (Array.isArray(tags)) {
            for (let i = 0; i < tags.length; i++) {
                queryString += '&' + taxonomy + '[]=' + tags[i];
            }
        }
        return queryString;
    },
    stripBaseUrl(url){
        if (typeof url !== 'string') {
            return '';
        }
        return url.replace(new RegExp('^' + escapeStringRegexp(this.host + this.baseUrl), 'i'), '');
    },
    stripHost(url){
        if (typeof url !== 'string') {
            return '';
        }
        return url.replace(new RegExp('^' + escapeStringRegexp(this.host), 'i'), '');
    },
    isExternalUrl(url) {
        return typeof url == 'string' && url.startsWith('http') == true && url.startsWith(this.host) == false;
    }
}
